/* SALAK: automatyczny wybór dostępnej kombinacji wariantów (motyw Stretch, snippets/variant-picker.liquid).
   Gdy klient klika wartość opcji (np. kolor), a wybrana wcześniej kula nie występuje z tym kolorem,
   skrypt przestawia pozostałe opcje na pierwszy dostępny wariant z klikniętą wartością, zanim motyw
   pobierze nową sekcję. Dzięki temu nie ma przekreślonego kółka ani ukrytej ceny.
   Wgrywane przez scripts/41-theme-variant-autoselect.mjs. */
(function () {
  if (window.__salakVariantAutoselect) return;
  window.__salakVariantAutoselect = true;

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.hasAttribute('data-option-position') || input.hasAttribute('data-product-url')) return;
    var formId = input.getAttribute('form');
    if (!formId) return;
    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
    var form = document.forms[formId];
    if (!picker || !form) return;
    var variantsEl = picker.querySelector('script[data-salak-variants]');
    var valuesEl = picker.querySelector('script[data-salak-values]');
    if (!variantsEl || !valuesEl) return;

    var variants, values;
    try {
      variants = JSON.parse(variantsEl.textContent); // [[["S","SALAK","HONEY"], 1], ...]  (opcje wariantu, dostępny 1/0)
      values = JSON.parse(valuesEl.textContent);     // { "<id wartości>": [pozycja opcji, "nazwa"] }
    } catch (e) { return; }

    var inputs = Array.prototype.filter.call(form.elements, function (el) {
      return el.matches && el.matches('input[data-option-position]');
    });
    var clicked = values[input.value];
    if (!clicked) return;
    var pos = clicked[0];

    var current = {};
    inputs.forEach(function (el) {
      var v = values[el.value];
      if (el.checked && v) current[v[0]] = v[1];
    });
    current[pos] = clicked[1];
    var positions = Object.keys(current).map(Number).sort(function (a, b) { return a - b; });

    var exists = variants.some(function (v) {
      return v[1] && positions.every(function (p) { return v[0][p - 1] === current[p]; });
    });
    if (exists) return;

    // Pierwszy dostępny wariant z klikniętą wartością; z pozostałych opcji zachowujemy jak najwięcej (wcześniejsze opcje ważniejsze).
    var best = null, bestScore = -1;
    variants.forEach(function (v) {
      if (!v[1] || v[0][pos - 1] !== clicked[1]) return;
      var score = 0;
      positions.forEach(function (p, i) {
        if (p !== pos && v[0][p - 1] === current[p]) score += positions.length - i;
      });
      if (score > bestScore) { bestScore = score; best = v[0]; }
    });
    if (!best) return;

    positions.forEach(function (p) {
      if (p === pos) return;
      var target = inputs.find(function (el) {
        var v = values[el.value];
        return v && v[0] === p && v[1] === best[p - 1];
      });
      if (target && !target.checked) target.checked = true;
    });
  }, true);
})();
